import { render } from "./LoadingNotification.vue?vue&type=template&id=1698868f&scoped=true"
import script from "./LoadingNotification.vue?vue&type=script&lang=js"
export * from "./LoadingNotification.vue?vue&type=script&lang=js"

import "./LoadingNotification.vue?vue&type=style&index=0&id=1698868f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1698868f"]])

export default __exports__